import React, { useState, useEffect, useCallback } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { ReactComponent as TrashIcon } from "../../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/EditBtn.svg";
import { ReactComponent as TickIcon } from "../../../assets/icons/ticky.svg";
import { ReactComponent as CrossIcon } from "../../../assets/icons/crossy.svg";
import { warning } from "../../../util/Alert";
import {
  getEngagement,
  createEngagement,
  editEngagement,
  deleteEngagement,
} from "../../store/reward/reward.action";
import {
  FormControl,
  TextField,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import Button from "../../extra/Button";

const EngagementRow = React.memo(
  ({
    item,
    onEdit,
    onDelete,
    isEditing,
    editValue,
    editStatus,
    onSubmit,
    onCancel,
    onChangeStatus,
    onChangeCoin,
  }) => (
    <div
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        border: "1px solid rgba(128, 128, 128, 0.4)",
        borderRadius: "20px",
        padding: "16px",
      }}
    >
      <span style={{ width: "140px" }}>{item.type}</span>
      {isEditing ? (
        <form onSubmit={onSubmit} className="flex items-center gap-3">
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <TextField
              value={editValue}
              onChange={(e) => onChangeCoin(e.target.value)}
              type="number"
              placeholder="Coins value"
            />
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={editStatus}
              onChange={(e) => onChangeStatus(e.target.value)}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              sx={{
                width: "100%",
                borderRadius: "9999px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "9999px", // Make the input fully rounded
                  padding: "8px 16px", // Adjust padding for a better look
                },
                "& .MuiSelect-select": {
                  borderRadius: "9999px",
                },
              }}
            >
              <MenuItem value={true}>Active</MenuItem>
              <MenuItem value={false}>Deactive</MenuItem>
            </Select>
            <Button
              newClass={"submit-btn-dialogue"}
              type={"submit"}
              btnIcon={<TickIcon />}
              style={{ backgroundColor: "white", width: "fit-content" }}
            />
            <Button btnIcon={<CrossIcon />} onClick={onCancel} />
          </div>
        </form>
      ) : (
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <span style={{ width: "40px" }}>{item.coins}</span>
          <span>{item.isActive ? "Active" : "Inactive"}</span>
          <Button btnIcon={<EditIcon />} onClick={() => onEdit(item)} />
          <Button
            btnIcon={<TrashIcon />}
            onClick={() => {
              onDelete(item._id);
            }}
          />
        </div>
      )}
    </div>
  ),
);

const EngagementReward = (props) => {
  const dispatch = useDispatch();
  const { engagement, engagementType } = useSelector((state) => state.reward);
  const [state, setState] = useState({
    editingId: null,
    editValue: "",
    editStatus: false,
    engagements: [],
  });
  const [coinError, setCoinError] = useState("");
  const [newCategory, setNewCategory] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [newCoin, setNewCoin] = useState("");
  const [underSubmisson, setUnderSubmission] = useState(false);
  useEffect(() => {
    dispatch(getEngagement());
  }, [dispatch]);

  useEffect(() => {
    if (engagement?.length)
      setState((prev) => ({
        ...prev,
        engagements: engagement,
      }));
  }, [engagement]);

  const reset = () => {
    setNewCategory("");
    setNewCoin("");
    setIsActive(true);
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    if (!newCategory) {
      return;
    }
    if (!newCoin) {
      setCoinError("Coins is required");
      return;
    }
    const body = {
      adName: newCategory,
      coins: parseInt(newCoin),
      isActive,
      type: newCategory,
    };
    setUnderSubmission(true);
    props.createEngagement(body);
    setUnderSubmission(false);
    reset();
  };

  const handleCancel = useCallback(() => {
    setState((prev) => ({
      ...prev,
      editingId: null,
      editValue: "",
    }));
  }, []);

  const handleEdit = useCallback((item) => {
    setState((prev) => ({
      ...prev,
      editingId: item._id,
      editStatus: item.isActive,
      editValue: String(item.coins),
    }));
  }, []);

  const handleSubmit = useCallback(
    async (e, item) => {
      e.preventDefault();
      const updatedItem = {
        ...item,
        coins: parseInt(state.editValue),
        isActive: state.editStatus,
      };
      await props.editEngagement(updatedItem, item._id);
      setState((prev) => ({
        ...prev,
        editingId: null,
        editStatus: false,
        editValue: "",
      }));
    },
    [state.editValue, state.editStatus],
  );

  const handleDelete = async (item) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          if (res.isConfirmed) {
            const id = item;
            props.deleteEngagement(id);
          }
        }
      })
      .catch((err) => console.log(err));
  };
  return (
    <div
      className="row search-action"
      style={{
        paddingRight: "3px",
        display: "flex",
        width: "100%",
        justifyContent: "center",
        border: "1px solid rgba(128, 128, 128, 0.4)",
        padding: "16px",
        borderRadius: "20px",
      }}
    >
      <h5
        style={{
          fontWeight: "500",
          fontSize: "20px",
          marginTop: "5px",
          marginBottom: "10px",
        }}
      >
        Engagement Reward
      </h5>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "100%",
        }}
      >
        {state.engagements.map((item) => (
          <EngagementRow
            key={item._id}
            item={item}
            isEditing={state.editingId === item._id}
            editValue={state.editValue}
            editStatus={state.editStatus}
            onEdit={handleEdit}
            onDelete={(id) => handleDelete(id)}
            onSubmit={(e) => handleSubmit(e, item)}
            onCancel={handleCancel}
            onChangeStatus={(val) =>
              setState((prev) => ({ ...prev, editStatus: val }))
            }
            onChangeCoin={(val) =>
              setState((prev) => ({ ...prev, editValue: val }))
            }
          />
        ))}
        {engagementType.length > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <FormControl
                sx={{
                  m: 2,
                  width: 190,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <InputLabel id="type-select-label">Select Type</InputLabel>
                <Select
                  labelId="type-select-label"
                  id="demo-simple-select"
                  value={newCategory}
                  label="Select Type"
                  onChange={(e) => setNewCategory(e.target.value)}
                  sx={{
                    width: "100%",
                    borderRadius: "9999px",
                    // '& .MuiInputLabel-root': {
                    //     color: 'black',
                    // },
                    // '& .MuiOutlinedInput-root': {
                    //     borderRadius: "9999px", // Make the input fully rounded
                    //     padding: "8px 16px", // Adjust padding for a better look
                    // },
                    // '& .MuiSelect-select': {
                    //     borderRadius: "9999px",
                    // },
                  }}
                >
                  {engagementType.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {newCategory && (
                <form onSubmit={handleAddSubmit}>
                  <FormControl>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <TextField
                        id="outlined-basic"
                        label="Reward Coins"
                        value={newCoin}
                        onChange={(e) => setNewCoin(e.target.value)}
                        error={coinError}
                        sx={{
                          width: "100%",

                          "& .MuiOutlinedInput-root": {
                            borderRadius: "9999px",
                            "&:hover fieldset": {
                              borderWidth: "1px",
                            },
                            "&.Mui-focused fieldset": {
                              borderWidth: "1px",
                            },
                          },
                        }}
                      />
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={isActive}
                        onChange={(e) => setIsActive(e.target.value)}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={{
                          width: "100%",
                          borderRadius: "9999px",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "9999px", // Make the input fully rounded
                            padding: "8px 16px", // Adjust padding for a better look
                          },
                          "& .MuiSelect-select": {
                            borderRadius: "9999px",
                          },
                        }}
                      >
                        <MenuItem value={true}>Active</MenuItem>
                        <MenuItem value={false}>Deactive</MenuItem>
                      </Select>
                      <Button
                        newClass={"submit-btn-dialogue"}
                        type={"submit"}
                        btnIcon={<TickIcon />}
                        disabled={underSubmisson}
                        style={{
                          backgroundColor: "white",
                          width: "fit-content",
                        }}
                      />
                      <Button
                        onClick={() => reset()}
                        btnIcon={<CrossIcon />}
                        disabled={underSubmisson}
                        style={{
                          backgroundColor: "white",
                          width: "fit-content",
                        }}
                      />
                    </div>
                  </FormControl>
                </form>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default connect(null, {
  getEngagement,
  createEngagement,
  editEngagement,
  deleteEngagement,
})(EngagementReward);
